import PropTypes from 'prop-types';
import * as formStyles from '../styles/styles.module.scss';
import * as baseStyles from '../../../styles/baseStyles.module.scss';
import * as styles from './styles/styles.module.scss';

// thinking this component might not be necessary 2022-05-01 junger
const Wrapper = ({ text, foot, children, showStepText, extraContainerClass }) => (
  <div>
    <div className={`${baseStyles.container} ${formStyles.container} ${styles.wrapper} ${extraContainerClass}`}>
      <div className={formStyles.head}>
        <div className={formStyles.subHead}>{text.headText}</div>
        <div className={formStyles.step}>{showStepText ? text.stepText : ''}</div>
      </div>
      {children}
      {foot && <div className={formStyles.foot}>{foot}</div>}
    </div>
  </div>
);

Wrapper.propTypes = {
  text: PropTypes.shape({
    headText: PropTypes.node
  }),
  foot: PropTypes.node,
  showStepText: PropTypes.bool,
  extraContainerClass: PropTypes.string
};

Wrapper.defaultProps = {
  text: {
    headText: 'Header'
  },
  foot: <div />,
  showStepText: false,
  extraContainerClass: ''
};

export default Wrapper;
